<template>
  <v-container id="timesheets" fluid tag="section">
    <v-row>
      <v-col cols="12" md="12">
        <idc-component-timesheets-entry v-if="canRead" :can-create="canCreate" :can-edit="canEdit" :can-delete="canDelete" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    name: 'IdcPageTimesheetsEntry',
    components: {
      IdcComponentTimesheetsEntry: () => import('@/components/idc/timesheets/entry/Timesheets.vue'),
    },
    props: {
      canRead: {
        type: Boolean,
        default: () => true,
      },
      canCreate: {
        type: Boolean,
        default: () => true,
      },
      canEdit: {
        type: Boolean,
        default: () => true,
      },
      canDelete: {
        type: Boolean,
        default: () => true,
      },
    },
  })
</script>
